import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-4">
              平台介绍
            </span>
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-900">
              {aboutData.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mt-6 leading-relaxed max-w-xl">
              {aboutData.description}
            </p>
            <p className="text-sm md:text-base text-foreground-600 mt-4 leading-relaxed max-w-xl">
              平台拥有超过10万部漫画资源，覆盖热血、奇幻、恋爱、武侠、悬疑等全类型题材。我们坚持免费阅读策略，通过智能推荐系统帮助每位用户发现心仪的作品，让漫画阅读成为每个人生活中触手可及的快乐。
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8">
              {aboutData.stats.map((stat) => (
                <div key={stat.label} className="text-center p-4 bg-background-100 rounded-xl">
                  <div className="text-xl md:text-2xl font-bold text-primary-600">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="flex-1 flex justify-center">
            <div className="w-full max-w-md rounded-2xl overflow-hidden">
              <img
                src={aboutData.image}
                alt="关于拷贝漫画"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}